import { getGlobal } from '../global';
export var isEditorX = function () { var _a, _b; return ((_b = (_a = getGlobal()) === null || _a === void 0 ? void 0 : _a.commonConfig) === null || _b === void 0 ? void 0 : _b.brand) === 'editorx'; };
//# sourceMappingURL=isEditorX.js.map